export const PAGE_PATH = '/auth/recovery';